import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './sidebar';

class BlogSlider extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL+'/'
    let customClass = this.props.customClass ? this.props.customClass :''
    let sectionClass = this.props.sectionClass ? this.props.sectionClass :''
    return (
      <div className={ "ltn__blog-area pt-115--- pb-70 go-top "+ sectionClass}>
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-12">
		        <div className="section-title-area ltn__section-title-2--- text-center">
		          <h6 className={"section-subtitle ltn__secondary-color "+customClass}>News &amp; Blogs</h6>
		          <h1 className="section-title">Latest News Feed</h1>
		        </div>
		      </div>
		    </div>
		    <div className="row  ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
		      {/* Blog Item */}
		      <div className="col-lg-12">
		        <div className="ltn__blog-item ltn__blog-item-3">
		          <div className="ltn__blog-img">
		            <Link to="/blog-details"><img src={publicUrl+"assets/img/blog/1.jpg"} alt="#" style={{ width: '800px'}} /></Link>
		          </div>
		          <div className="ltn__blog-brief">
		            {/* <div className="ltn__blog-meta">
		              <ul>
		                <li className="ltn__blog-author">
		                  <Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
		                </li>
		                <li className="ltn__blog-tags">
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Interior</Link>
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Decorate</Link>
		                </li>
		              </ul>
		            </div> */}
		            <h3 className="ltn__blog-title"><Link to="/blog-details">Why Investing in Land is a Smart Long-Term Move</Link></h3>
		            <div className="ltn__blog-meta-btn">
		              {/* <div className="ltn__blog-meta">
		                <ul>
		                  <li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2021</li>
		                </ul>
		              </div> */}
		              <div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
		                <Link to="/blog-details">Read more</Link>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      {/* Blog Item */}
		      <div className="col-lg-12">
		        <div className="ltn__blog-item ltn__blog-item-3">
		          <div className="ltn__blog-img">
		            <Link to="/blog-details-2"><img src={publicUrl+"assets/img/blog/2.jpg"} alt="#" style={{ width: '800px'}} /></Link>
		          </div>
		          <div className="ltn__blog-brief">
		            {/* <div className="ltn__blog-meta">
		              <ul>
		                <li className="ltn__blog-author">
		                  <Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
		                </li>
		                <li className="ltn__blog-tags">
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Interior</Link>
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Interior</Link>
		                </li>
		              </ul>
		            </div> */}
		            <h3 className="ltn__blog-title"><Link to="/blog-details-2">Top Mistakes First-Time Plot Buyers Make — and How to Avoid Them</Link></h3>
		            <div className="ltn__blog-meta-btn">
		              {/* <div className="ltn__blog-meta">
		                <ul>
		                  <li className="ltn__blog-date"><i className="far fa-calendar-alt" />July 23, 2021</li>
		                </ul>
		              </div> */}
		              <div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
		                <Link to="/blog-details-2">Read more</Link>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      {/* Blog Item */}
		      <div className="col-lg-12">
		        <div className="ltn__blog-item ltn__blog-item-3">
		          <div className="ltn__blog-img">
		            <Link to="/blog-details-3"><img src={publicUrl+"assets/img/blog/3.jpg"} alt="#" style={{ width: '800px'}} /></Link>
		          </div>
		          <div className="ltn__blog-brief">
		            {/* <div className="ltn__blog-meta">
		              <ul>
		                <li className="ltn__blog-author">
		                  <Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
		                </li>
		                <li className="ltn__blog-tags">
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Interior</Link>
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Estate</Link>
		                </li>
		              </ul>
		            </div> */}
		            <h3 className="ltn__blog-title"><Link to="/blog-details-3">The Rise of Sustainable Living: Why Green Plots Are Gaining Popularity</Link></h3>
		            <div className="ltn__blog-meta-btn">
		              {/* <div className="ltn__blog-meta">
		                <ul>
		                  <li className="ltn__blog-date"><i className="far fa-calendar-alt" />May 22, 2021</li>
		                </ul>
		              </div> */}
		              <div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px' }}>
		                <Link to="/blog-details-3">Read more</Link>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      {/* Blog Item */}
		      <div className="col-lg-12">
		        <div className="ltn__blog-item ltn__blog-item-3">
		          <div className="ltn__blog-img">
		            <Link to="/blog-details-4"><img src={publicUrl+"assets/img/blog/4.jpg"} alt="#" style={{ width: '800px'}} /></Link>
		          </div>
		          <div className="ltn__blog-brief">
		            {/* <div className="ltn__blog-meta">
		              <ul>
		                <li className="ltn__blog-author">
		                  <Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
		                </li>
		                <li className="ltn__blog-tags">
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Interior</Link>
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Room</Link>
		                </li>
		              </ul>
		            </div> */}
		            <h3 className="ltn__blog-title"><Link to="/blog-details-4">What to Look for in a Gated Layout Before You Invest</Link></h3>
		            <div className="ltn__blog-meta-btn">
		              {/* <div className="ltn__blog-meta">
		                <ul>
		                  <li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2021</li>
		                </ul>
		              </div> */}
		              <div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
		                <Link to="/blog-details-4">Read more</Link>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      {/* Blog Item */}
		      <div className="col-lg-12">
		        <div className="ltn__blog-item ltn__blog-item-3">
		          <div className="ltn__blog-img">
		            <Link to="/blog-details-5"><img src={publicUrl+"assets/img/blog/5.jpg"} alt="#" style={{ width: '800px'}} /></Link>
		          </div>
		          <div className="ltn__blog-brief">
		            {/* <div className="ltn__blog-meta">
		              <ul>
		                <li className="ltn__blog-author">
		                  <Link to="/team-details"><i className="far fa-user" />by: Admin</Link>
		                </li>
		                <li className="ltn__blog-tags">
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Interior</Link>
		                  <Link to="/blog-grid"><i className="fas fa-tags" />Trends</Link>
		                </li>
		              </ul>
		            </div> */}
		            <h3 className="ltn__blog-title"><Link to="/blog-details-5">How to Choose the Right Location for Your Future Home</Link></h3>
		            <div className="ltn__blog-meta-btn">
		              {/* <div className="ltn__blog-meta">
		                <ul>
		                  <li className="ltn__blog-date"><i className="far fa-calendar-alt" />June 24, 2021</li>
		                </ul>
		              </div> */}
		              <div className="ltn__blog-btn" style={{ backgroundColor: '#A3BA3F', color: '#fff', padding: '10px', borderRadius: '10px'}}>
		                <Link to="/blog-details-5">Read more</Link>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      {/*  */}
		    </div>
		  </div>
		</div>
    )
  }
}

export default BlogSlider;
